import { useMemo, useEffect } from 'react';
import { DragSourceImpl } from './8f0f607b0ebb2e5a75ec190901ab0c3ae203a30905281eddcf5a66cc92752267.cfe-internal.js';

function useDragSource(spec, monitor, connector) {
  var handler = useMemo(function () {
    return new DragSourceImpl(spec, monitor, connector);
  }, [monitor, connector]);
  useEffect(function () {
    handler.spec = spec;
  }, [spec]);
  return handler;
}

export { useDragSource };
